import { Props } from "./Cupones.type"
import React from "react";
import { Box, Button, createTheme, FormControlLabel, Grid, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ThemeProvider } from "@mui/material";
import { esES } from "@mui/material/locale";
import { PencilIcon, VisibilityIcon } from "@/toolbox/constants/icons";
import DeleteIcon from '@mui/icons-material/Delete';
import { Popup } from "@/views/Editor/components/Popup";
import { Loading } from "@/components/common/Loading";
import { CuponesService } from "@/service/services/Cupones.service";
import { CuponModal } from "./componentes/CuponModal";
import { DeleteCuponModal } from "./componentes/DeleteCuponModal";

const theme = createTheme(
    {
        palette: {
            primary: { main: '#1976D2' },
        },
    },
    esES,
);

export const Cupones: React.FC<Props> = (props: Props):JSX.Element => {

    const {cupones, onListCupones} = props;

    const [openPopup, setOpenPopup] = React.useState<boolean>(false);
    const [popUp, setPopUp] = React.useState<String>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [detailMode, setDetailMode] = React.useState<boolean>(false);

    const [selectedCupon, setSelectedCupon] = React.useState<any>('');
    const [showModalDelete, setShowModalDelete]= React.useState(false);

    const openModalDelete=()=>{
        setShowModalDelete(true);
    }

    const closeModalDelete=()=>{
        setShowModalDelete(false);
    }

    const funcionSwitch = async (cupon)=>{
        setLoading(true);
        if(cupon.state === 1){
            await CuponesService.updateStatus(cupon.id,0);
        }else{
            await CuponesService.updateStatus(cupon.id,1);
        }
        onListCupones && onListCupones();
    }

    return (
        <Grid>
            {loading && <Loading/>}
            <Box sx={{Width: '100%', marginTop:'0px'}}>
                <TableContainer component={Paper}>
                    <ThemeProvider theme={theme}>
                        <Table aria-label="simple table" size='small'>
                            <TableHead>
                                <TableRow  sx={{ bgcolor:'#1976D2'}}>
                                    <TableCell sx={{ color: 'white' }} >
                                        <strong>N°</strong>
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white' }} >
                                        <strong>Fecha de Inicio</strong>
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white' }} >
                                        <strong>Fecha de Caducidad</strong>
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white' }} >
                                        <strong>Estado</strong>
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white' , minWidth:'8rem', maxWidth:'12rem'}}><strong>Acciones</strong></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {
                                    cupones && cupones.map((item, id) =>(
                                        <TableRow key={id}>
                                            <TableCell component="th" scope="row">
                                                {id+1}
                                            </TableCell>
                                            <TableCell align='center' component="th" scope="row">
                                                {item.fecha_inicio}
                                            </TableCell>
                                            <TableCell align='center' component="th" scope="row">
                                                {item.fecha_fin}
                                            </TableCell>
                                            <TableCell align='center' component="th" scope="row">
                                                <Box>
                                                <FormControlLabel
                                                    control={<Switch onClick={() => {
                                                        funcionSwitch(item);
                                                    }}
                                                />}
                                                checked={item.state === 1 ? true : false}
                                                label=""
                                                />
                                                </Box>
                                            </TableCell>
                                            <TableCell align='center' sx={{width: '12rem'}}>
                                                <Button
                                                    onClick={() =>  {
                                                        setOpenPopup(true);
                                                        setDetailMode(true);
                                                        setPopUp('detailCupon');
                                                        setSelectedCupon(item);
                                                    }}
                                                >
                                                    <VisibilityIcon/>
                                                </Button>
                                                
                                                <Button
                                                    onClick={() =>  {
                                                        setOpenPopup(true);
                                                        setDetailMode(false);
                                                        setPopUp('editCupon');
                                                        setSelectedCupon(item);
                                                    }}
                                                >
                                                    <PencilIcon/>
                                                </Button>

                                                <Button color="error"
                                                    onClick={() =>  {
                                                        setOpenPopup(true);
                                                        openModalDelete();
                                                        setPopUp('delete');
                                                        setSelectedCupon(item);
                                                    }}
                                                >
                                                    <DeleteIcon/>
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </ThemeProvider>
                </TableContainer>
            </Box>
            {
                popUp === 'detailCupon'  && (
                    <Popup
                        largo="sm"
                        title = {'Detalle del Cupón'}
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                    >
                        <CuponModal
                            onListCupones={onListCupones}
                            closeModal={() => {setOpenPopup(false)}}
                            cuponSelected={selectedCupon}
                            detailMode={detailMode}
                        />
                    </Popup>
                )
            }
            {
                popUp === 'editCupon'  && (
                    <Popup
                        largo="sm"
                        title = {'Editar Cupón'}
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                    >
                        <CuponModal
                            onListCupones={onListCupones}
                            closeModal={() => {setOpenPopup(false)}}
                            cuponSelected={selectedCupon}
                            detailMode={detailMode}
                        />
                    </Popup>
                )
            }
            {
                popUp === 'delete'  && (
                    <DeleteCuponModal
                        open={showModalDelete}
                        closeModal={closeModalDelete}
                        cupon={selectedCupon}
                        onListCupones={onListCupones}
                    />
                )
            }
        </Grid>
    )
}